module.exports = __webpack_public_path__ + "static/img/badge-larvicide-active.901b23f.svg";